import { Card } from '@popsure/dirty-swan';
import Image from 'next/image';
import StrapiRichText from 'strapi/components/StrapiRichText';
import { BlockComponentProps } from 'strapi/types/utils';

import styles from './AddonSection.module.scss';

const ADDONS_MIN = 2;
const ADDONS_MAX = 4;

export const AddonSectionComponent = ({
  block,
  onError,
}: BlockComponentProps<'marketing-website.addon-section'>) => {
  const { title, description, image, items: addons } = block;

  const shouldShowAddons =
    addons && addons.length >= ADDONS_MIN && addons.length <= ADDONS_MAX;

  if (!title) return onError('Missing title');
  if (!description) return onError('Missing description');
  if (!image?.data) return onError('Missing image data');
  if (!image.data.attributes.alternativeText)
    return onError('Missing image alt text');
  if (!shouldShowAddons)
    return onError(
      `Missing addon or addons should be between ${ADDONS_MIN} and ${ADDONS_MAX}`
    );

  return (
    <section className={`bg-grey-100 py24 mt56 ${styles.container}`}>
      <div className="p-body">
        <header className={`d-flex gap24 mb32 ${styles.headerContainer}`}>
          <div>
            <h2 className="p-h2 p--serif mb8 ta-center">{title}</h2>
            <p>{description}</p>
          </div>
          <div className={`${styles.imgContainer}`}>
            <Image
              alt={image.data.attributes.alternativeText}
              src={image.data.attributes.url}
              fill
              style={{
                objectFit: 'cover',
              }}
            />
          </div>
        </header>
        <div className={`${styles.addonsContainer} d-grid gap16`}>
          {addons.map((addon) => {
            if (!addon.card_title) return onError('Missing icon title');
            if (!addon.card_icon?.data) return onError('Missing icon');
            if (!addon.card_icon.data.attributes.alternativeText)
              return onError('Missing icon alt text');

            return (
              <Card
                key={addon.card_title}
                icon={
                  <Image
                    src={addon.card_icon.data.attributes.url}
                    alt={addon.card_icon.data.attributes.alternativeText}
                    width={48}
                    height={48}
                  />
                }
                title={addon.card_title}
                dropShadow={false}
                description={
                  <StrapiRichText
                    richText={addon.card_description}
                    paragraphClassName="tc-grey-600"
                  />
                }
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};
